var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailySchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u1F3EB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3 4.53232L16.2042 2.87932C16.6476 2.69152 16.6476 2.06332 16.2042 1.87552L12.2148 0.186523C12.267 0.240523 12.3 0.313723 12.3 0.394723V4.53232Z",
    fill: "#4592FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3 4.71953V0.394727C12.3 0.313727 12.267 0.240527 12.2148 0.186527C12.1602 0.130127 12.0846 0.0947266 12 0.0947266C11.8344 0.0947266 11.7 0.229127 11.7 0.394727V4.71953C11.8896 4.61873 12.1104 4.61873 12.3 4.71953Z",
    fill: "#333D4B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4044 22.6242H20.3058C21.0204 22.6242 21.6 22.0446 21.6 21.33V10.3752H15.4044V22.6242Z",
    fill: "#D0D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.40002 10.3746V21.3294C2.40002 22.044 2.97962 22.6236 3.69422 22.6236H8.59562V10.374L2.40002 10.3746Z",
    fill: "#D0D5DA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.6 9.72601V10.374H15.402L12 6.95401L8.59802 10.374H2.40002V9.72601C2.40002 9.01201 2.98202 8.43001 3.69602 8.43001H7.95002L11.544 4.82401C11.586 4.77601 11.646 4.75201 11.7 4.72201C11.892 4.62001 12.108 4.62001 12.3 4.72201C12.354 4.75201 12.414 4.77601 12.456 4.82401L16.05 8.43001H20.304C21.018 8.43001 21.6 9.01201 21.6 9.72601Z",
    fill: "#4592FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4044 10.3746L12 6.95337L8.59558 10.3746V22.6242H15.4044V10.3746ZM13.6182 22.6242H10.3824V20.112C10.3824 19.7124 10.7064 19.3884 11.106 19.3884H12.8946C13.2942 19.3884 13.6182 19.7124 13.6182 20.112V22.6242ZM12 14.814C10.7742 14.814 9.78058 13.8204 9.78058 12.5952C9.78058 11.37 10.7742 10.3758 12 10.3758C13.2258 10.3758 14.2194 11.3694 14.2194 12.5952C14.2194 13.821 13.2258 14.814 12 14.814Z",
    fill: "#E5E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12 10.3752C10.7742 10.3752 9.78058 11.3688 9.78058 12.5946C9.78058 13.8204 10.7742 14.8134 12 14.8134C13.2258 14.8134 14.2194 13.8198 14.2194 12.5946C14.2194 11.3694 13.2258 10.3752 12 10.3752ZM12.3 12.9H10.9356C10.77 12.9 10.6356 12.7656 10.6356 12.6C10.6356 12.4344 10.77 12.3 10.9356 12.3H11.7V11.2128C11.7 11.0472 11.8344 10.9128 12 10.9128C12.1656 10.9128 12.3 11.0472 12.3 11.2128V12.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.8946 19.3879H11.106C10.7064 19.3879 10.3824 19.7119 10.3824 20.1115V22.6237H13.6182V20.1115C13.6182 19.7119 13.2942 19.3879 12.8946 19.3879Z",
    fill: "#6B7683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12 10.9128C11.8344 10.9128 11.7 11.0472 11.7 11.2128V12.3H10.9356C10.77 12.3 10.6356 12.4344 10.6356 12.6C10.6356 12.7656 10.77 12.9 10.9356 12.9H12.3V11.2128C12.3 11.0472 12.1656 10.9128 12 10.9128Z",
    fill: "#6B7683"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailySchool);
export default __webpack_public_path__ + "static/media/daily_school.9ef3649152a19bcdf40186bc7a3092fb.svg";
export { ForwardRef as ReactComponent };